import theme from "@/theme";

export const styles = {
  wrapper: {
    width: "100%",
    maxWidth: "519px",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    bgcolor: "#fff",
    padding: "56px 54.5px 40px 54.5px",
    boxShadow: "0px 0px 25px 0px rgba(22, 22, 22, 0.05)",
    borderRadius: "1.5rem",
  },

  inputLabel: {
    fontSize: "16px",
    lineHeight: "100%",

    color: theme.palette.custom.blueGray900,
    fontWeight: 500,
  },

  inputProps: {
    sx: {
      marginTop: "0.625rem",
      borderRadius: "3.125rem",
      fontSize: "1rem",
      backgroundColor: "#fff",
      "& input:-webkit-autofill": {
        boxShadow: "0 0 0px 1000px #fff inset",
        WebkitTextFillColor: "#383C40",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#D6D6D6",
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#D6D6D6",
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#D6D6D6",
      },
      "& .MuiInputBase-input": {
        color: "##383C40",
      },
    },
  },

  TextFieldProps: {
    sx: {
      borderRadius: "1.125rem",
      fontSize: "1rem",
    },
  },

  continueButton: {
    height: "50px",
    fontSize: "1rem",
    textTransform: "none",
    borderRadius: "1.75rem",
    "&.Mui-disabled": {
      backgroundColor: "#8BC5F4",
      color: "#fff",
    },
  },

  waitlistText: {
    fontFamily: "Inter, sans-serif",
    fontWeight: 500,
    fontSize: "15px",
    lineHeight: "24px",
    color: "rgba(20, 71, 230, 0.8)",
    textAlign: "center",
    marginBottom: "12px",
  },

  waitlistLink: {
    fontWeight: 600,
    lineHeight: "22px",
    textDecoration: "underline",
    cursor: "pointer",
  },

  inviteButton: {
    height: "50px",
    fontSize: "1rem",
    textTransform: "none",
    borderRadius: "1.75rem",
    "&.Mui-disabled": {
      backgroundColor: "#C6CACE",
      color: "#fff",
    },
  },

  svgIcon: {
    width: "24px",
    cursor: "pointer",
    height: "24px",
  },

  Link: {
    fontFamily: "Inter, sans-serif",
    fontWeight: 600,
    fontSize: "15px",
    lineHeight: "22px",
    letterSpacing: "0%",
    textDecoration: "underline",
    textDecorationColor: theme.palette.custom.mainBlue,
    textDecorationThickness: "1px",
    textUnderlineOffset: "3px",
    cursor: "pointer",
  },
};
